<template>
  <div class="aboutwe">
    <div class="wrap" style="zoom:70%">
      <img src="../assets/img/aboutus/img20.png" />
    </div>
    <div class="ht20"></div>
    <div class="wrap2" style="zoom:70%">
      <div class="about_box">
        <div class="img"><img src="../assets/img/about_txt.jpg" /></div>
        <div class="text" style="margin-left: 100px;">
          <h2 style="color:#00237d;font-size:42px;">
            {{ $t("menus.aboutus") }}
          </h2>
          <p>
            {{ $t("aboutus.info1") }}
          </p>
          <p>
            {{ $t("aboutus.info2") }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      languages: 0,
    };
  },
  computed: {
    ProList() {
      return [
        {
          img: require("../assets/img/picture1.jpg"),
          tit: this.$t("aboutus.team"),
          des: "",
        },
        {
          img: require("../assets/img/picture2.jpg"),
          tit: this.$t("aboutus.client"),
          des: "",
        },
        {
          img: require("../assets/img/picture3.jpg"),
          tit: this.$t("aboutus.network"),
          des: "",
        },
        {
          img: require("../assets/img/picture4.jpg"),
          tit: this.$t("aboutus.onoffline"),
          des: "",
        },
      ];
    },
  },
  components: {},
  created() {
    document.documentElement.scrollTop = 0;
    console.log(this.$i18n.locale);
    if (this.$i18n.locale == "zh") {
      this.languages = 1;
      console.log("1111111");
    } else {
      this.languages = 2;
      console.log("22222222");
    }
    console.log(this.languages);
  },
};
</script>

<style lang="scss" scoped>
.wrap2 {
  max-width: 1600px;
  width: 90%;
  margin: 0 auto;
}
.aboutwe {
  min-height: calc(100vh - 150px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
